// Colour values live in ColumnCalculation.css (BEM modifier classes per scope).

export const SCOPE_KEYS = ['all', 'selected'];

export const SCOPE_LABELS = {
  all: 'All Records',
  selected: 'Selected Rows (Total)',
};
